export default __webpack_public_path__ + "static/media/orbits-purple-logo.3e5051e4.svg";